import React from 'react'
import PropTypes from 'prop-types'
import format from 'date-fns/format'
import { cx } from '@emotion/css'

import QuestionCircleOutlineIcon from '@offerzen/zenicon/QuestionCircleOutlineIcon'
import { matchesMediaQuery } from '../../../styles/helpers'
import { colors } from '../../../themes'
import { IANATimeZoneName } from '../../../helpers/datetimeHelpers'
import AccessibleText from '../../../elements/AccessibleText'
import Tooltip from '../../../elements/Tooltip'
import AccessibleIcon from '../../../elements/AccessibleIcon'
import PopupTip from '../../../elements/PopupTip'

import styles from './styles'

const timeZoneName = IANATimeZoneName()

const TimeRange = ({ startTime, endTime, tooltipBreakpoint, wrappingElement, className }) => {
  const WrappingElement = wrappingElement || 'div'

  return (
    <WrappingElement className={cx(styles.wrapper, className)}>
      {format(startTime, 'HH:mm')}
      <AccessibleText displayText="–" accessibleText="to" />
      {format(endTime, 'HH:mm ([GMT]Z)')}
      {matchesMediaQuery(tooltipBreakpoint) ? (
        <Tooltip
          icon={QuestionCircleOutlineIcon}
          size={16}
          color={colors.jumbo}
          trigger={AccessibleIcon}
          position="top"
          className={styles.tooltip}>
          {timeZoneName}
        </Tooltip>
      ) : (
        <PopupTip
          icon={QuestionCircleOutlineIcon}
          size={24}
          color={colors.jumbo}
          className={styles.popupTip}
          triggerClassName={styles.popupTipIcon}
          trigger={AccessibleIcon}>
          {timeZoneName}
        </PopupTip>
      )}
    </WrappingElement>
  )
}

TimeRange.propTypes = {
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  tooltipBreakpoint: PropTypes.number,
  wrappingElement: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  className: PropTypes.string,
}

export default TimeRange
